<template>
  <div id="wrap">
    <header-area ref="headerAreaRef"></header-area>
    <router-view></router-view>
    <common-loading></common-loading>
    <logistics-notification></logistics-notification>
    <footer-area></footer-area>
  </div>
</template>

<script>
import HeaderArea from '../components/HeaderArea'
import FooterArea from '../components/FooterArea'
import LogisticsNotification from "@/components/LogisticsNotification";

export default {
  name: 'MainLayout',
  components: {
    FooterArea,
    HeaderArea,
    LogisticsNotification
  },
  data () {
    return {

    }
  }
}
</script>

